import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import ScrollContainer from '../../../../../components/ScrollContainer'
import Spinner from '../../../../../components/Spinner'
import VideolistAllItem from '../../../../../components/ContentVideo/VideolistAllItem'
import Empty from '../PlaylistSongs/Empty'
import List from '../../../../../components/List'
import { loadVideolistsAll, toggleSelectedVideolistAll, sortAllVideolists, clearTrackSummery, downloadTrackSummery } from '../../../../../store/ContentAllVideolists/actions'
import { isMobile } from '../../../../../utilities/media'
import { getNextSelected } from '../../../../../utilities/getNextSelected'
import Button from '../../../../../components/Button'
import SvgArrowUpDown from '../../../../../components/SVG/ArrowUpDown'
import { getVideoPlaylistsAll } from '../../../../../store/Search/extraSelectors'
import { store } from '../../../../../connect'

const AllVideolists = ({
    searchActive,
    searchFounded = [],
    videolists = [],
    toggleSelected,
    allVideolists,
    loadVideolistsAll,

    selectedVideolists,
    toggleSelectedVideolistAll,
    selected,
    dnd_result,
    loading,
    sortAllVideolists,
    onlyOne,
    summary_clips_length,
    selected_clips,
    downloadTrackSummery,
    clearTrackSummery
}) => {
    const [sort_direction, setSortDirection] = useState("")


    const sort = (type) => {
        setSortDirection(sort_direction === "up" ? "down" : "up")
        sortAllVideolists({ direction: sort_direction, sort_type: type })
    }
    useEffect(() => {
        loadVideolistsAll()
    }, [])
    //if (searchActive) allPlaylists = searchFounded
    videolists = allVideolists
    const hToggleSelected = (e) => {

        const videolist = e.target.closest(".Videolist")
        if (videolist) {
            const videolistId = Number(videolist.dataset.videolistId)

            if (!isNaN(videolistId)) {
                const selected = getNextSelected({
                    multiple: true,
                    itemId: videolistId,
                    items: allVideolists,
                    selected: selectedVideolists,
                    shiftKey: e.shiftKey,
                    ctrlKey: (isMobile() || e.ctrlKey || e.metaKey),
                    // shiftKey: onlyOne ? false : e.shiftKey,
                    // ctrlKey: onlyOne ? false : (isMobile() || e.ctrlKey || e.metaKey),
                })

                toggleSelectedVideolistAll({
                    selected,
                    simple: true,
                })
            }
        }
    }



    const getItems = () => {
        return allVideolists.map((videolist, index) => ({
            id: videolist.id,
            name: videolist.name,
            element: < VideolistAllItem
                // className="AdditionalSettings AdditionalSettings_videolist_all"
                key={videolist.id}
                id={videolist.id}
                name={videolist.name}
                totalcount={videolist.totalcount}
                totalsize={videolist.totalsize2}
                totaltime={videolist.totaltime}
                songs={videolist.songs}
                variant={(index % 2 == 0) ? "gray" : ""}
                onlyOne
            />
        }))
    }




    const showVideoLists = () => {

        downloadTrackSummery(selected_clips)
    }


    return (
        <section className="Videolists" style={{ width: "37%" }}>
            <h2>ВСЕ СПИСКИ</h2>
            <div style={{
                width: 200,
                height: 20,
                // textAlign: 'center',
                // cursor: showSummeryCancel ? 'pointer' : null
            }}
            // onClick={showSummeryCancel ? () => clearTrackSummery() : undefined}
            >
                {/* {showSummeryCancel ? "Убрать списки с этим файлом" : null} */}
            </div>
            <div onClick={hToggleSelected} style={{ marginTop: 34 }}>
                <header className="Videolists__control">
                    <div className="Videolists__grid">
                        <div className="name_public">
                            <Button
                                type="string"
                                onClick={() => sort("name")}
                            >
                                <SvgArrowUpDown title="Сортировка по название плейлиста" />
                                НАЗВАНИЕ
                            </Button>
                        </div>
                        <div className="tracks_count_public">
                            <Button
                                type="string"
                                onClick={() => sort("songs")}
                            >
                                <SvgArrowUpDown title="Сортировка по кол-ву треков" />
                                ТРЕКОВ
                            </Button>
                        </div>
                        <div className="size_public">
                            <Button
                                type="string"
                                onClick={() => sort("size")}
                            >
                                <SvgArrowUpDown title="Сортировка по размеру плейлиста" />
                                РАЗМЕР
                            </Button>
                        </div>
                        <div className="duration_public">
                            <Button
                                type="string"
                                onClick={() => sort("duration")}
                            >
                                <SvgArrowUpDown title="Сортировка по длительности" />
                                ДЛИТ.
                            </Button>
                        </div>
                    </div>
                </header>
                {(loading && !videolists.length)
                    ? <Spinner className="pt-xs pb-xs" />
                    : videolists.length > 0
                        ? <List
                            type="simple"
                            scroll={{
                                on: true,
                                data: {
                                    variant: "white",
                                    size: "lg",
                                }
                            }}
                            // variant={ "none" }
                            content={{ items: getItems(), variant: "none" }}
                        />

                        : <Empty title="Плейлистов пока нет." />
                }
                {/* {selected_clips.length || summary_clips_length?
                    <button
                        onClick={summary_clips_length ? clearTrackSummery : showVideoLists}
                        className='spp-btn leftMarker cancelSummaryButton'
                    >
                        {summary_clips_length ? "Убрать выделенные" : "Показать списки с выбранными видео"}
                    </button>
                    : null} */}
            </div>
        </section>
    )
}

const stateToProps = state => ({
    allVideolists: getVideoPlaylistsAll(state),
    loading: state.videolists_all.loading,
    selectedVideolists: [...state.videolists_all.selected],
    selected: [...state.videolists_all.selected],
    selected_clips: state.videolists_all.selected_video,
    summary_clips_length: state.videolists_all.clipSummery.clips.length

})

const actionsToProps = {
    loadVideolistsAll,
    toggleSelectedVideolistAll,
    sortAllVideolists,
    downloadTrackSummery,
    clearTrackSummery
}
export default connect(stateToProps, actionsToProps)(AllVideolists)